import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { inputTypesEnum } from '../../../enums/input-type';
import { SelectComponent } from '../../../../ui-components/lib/select/select.component';
import { InputComponent } from '../../../../ui-components/lib/input/input.component';
import { CheckboxComponent } from '../../../../ui-components/lib/checkbox/checkbox.component';
import { RadioButtonComponent } from '../../../../ui-components/lib/radio-button/radio-button.component';
import { TextareaComponent } from '../../../../ui-components/lib/textarea/textarea.component';
import { DatePickerComponent } from '../../../../ui-components/lib/date-picker/date-picker.component';
import { MoneyInputComponent } from '../../../../ui-components/lib/money-input/money-input.component';
import { MobileInputComponent } from '../../../../ui-components/lib/mobile-input/mobile-input.component';
import { DualLangInputComponent } from '../../dual-lang-input/dual-lang-input.component';
import { DualLangTextAreaComponent } from '../../dual-lang-text-area/dual-lang-text-area.component';
import { UploadFilesComponent } from '../../../../ui-components/lib/upload-files/upload-files.component';
import { LookupFieldComponent } from '../../../../ui-components/lib/lookup-field/lookup-field.component';
import { AssignList } from '../../../../ui-components/lib/lookup-field/lookup-field-item';

export interface FieldStaticPreviewOption {
  value: string;
  label: { en: string; ar: string };
}

@Component({
  selector: 'lib-form-builder-field-static-preview',
  imports: [
    ReactiveFormsModule,
    SelectComponent,
    InputComponent,
    CheckboxComponent,
    RadioButtonComponent,
    TextareaComponent,
    DatePickerComponent,
    MoneyInputComponent,
    MobileInputComponent,
    DualLangInputComponent,
    DualLangTextAreaComponent,
    UploadFilesComponent,
    LookupFieldComponent,
  ],
  templateUrl: './form-builder-field-static-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormBuilderFieldStaticPreviewComponent {
  readonly inputTypesEnum = inputTypesEnum;

  fieldType = input.required<string>();
  fieldLabel = input.required<string>();
  isRequired = input<boolean>(false);
  placeholder = input<string | null>(null);
  hint = input<string | null>(null);
  options = input<FieldStaticPreviewOption[]>([]);

  readonly mappedOptions = computed(() =>
    this.options().map(opt => ({
      value: opt.value,
      label: opt.label.en || opt.label.ar,
    }))
  );

  readonly singleCheckOption = computed(() => [
    { value: 'true', label: this.fieldLabel() },
  ]);

  readonly lookupPreviewAssignList: AssignList = {
    label: 'label',
    value: 'value',
    icon: '',
    extraLabels: [],
  };

  readonly previewForm = new FormGroup({ value: new FormControl(null) });

  readonly dualLangPreviewForm = new FormGroup({
    label: new FormGroup({
      en: new FormControl(''),
      ar: new FormControl(''),
    }),
  });
}
